function BaseStepModel(panelId) {
    var self = this;
    self.id = panelId;
    self.isDone = ko.observable(false);
    self.isCanceled = ko.observable(false);

    self.validationErrors = ko.observableArray([]);
    self.hasValidationErrors = ko.computed(function() {
        return self.validationErrors() && self.validationErrors().length > 0;
    });

    self.resetState = function () {
        self.isDone(false);
        self.isCanceled(false);
        self.validationErrors([]);
    };

    self.hide = function() {
        $('#' + self.id).addClass('hidden');
    };
}